import React from 'react'
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';

export default function BackButton(props) {
    const history = useHistory();
    return (
        <div className={props?.className}>
            <button
                type="button"
                onClick={() => props?.to ? history.push(props?.to) : history.goBack()}
                className="cursor-pointer flex items-center justify-center w-8 h-8 border rounded-full hover:bg-blue-500 hover:text-white"  >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
            </button>
        </div>

    )
}

BackButton.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
};
